export const GridConfig = {
  dateFormat: "yyyy-MM-dd hh:mm a",
};
